import request from '@/utils/request'

export function GetHistoryFeedbacks(params){
  return request({
    url: 'wx/work-order',
    method: 'get',
    params
  })
}

export function GetHistoryFeedbackInfo(id){
  return request({
    url: 'wx/work-order/'+id,
    method: 'get'
  })
}

export function PostSatisfaction(data){
  return request({
    url: 'wx/work-order/satisfaction',
    method: 'post',
    data
  })
}

export function PostSecondSatisfaction(data){
  return request({
    url: 'wx/work-order/second-satisfaction',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Feedback.js


// WEBPACK FOOTER //
// ./src/api/Feedback.js